module.exports = __webpack_public_path__ + "img/about-buying-selling.9fe85f3e.png";